module.exports = "/_next/static/images/Hero@2x-6fd2da90b8a06e5d093638c7ef6e9dfe.png";